import WasmController from "react-lib/frameworks/WasmController";
import { State as MainState } from "react-lib/apps/segment/SegmentInterface";

// APIs
import {
  ListDataType,
  RuleTemplatesType,
  SegmentItem,
  PostItem,
  ListSegmentTreesType,
  SegmentData,
  typeAction,
} from "react-lib/apps/segment/segmentTreeType";
import {
  Timestamp,
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
  getDoc,
  serverTimestamp,
  updateDoc,
  deleteDoc,
  deleteField,
  runTransaction,
  getDocFromServer,
  onSnapshot,
  increment,
} from "firebase/firestore";
import { getStorage, ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";
import { getApp } from "firebase/app";

import CONFIG from "config/config";

export type State = {
  SegmentTargetSequence: {
    sequenceIndex?: string | null;
    organsMaster: any[];
    loadingSegmentList?: boolean;
    listSegmentTrees?: ListSegmentTreesType[];
    ruleTemplates?: RuleTemplatesType[];
    listSegments?: SegmentItem[];
    contentList?: PostItem[];
    selectedSegmentId?: string;
    selectedSegmentTreeId?: string;
    organTips?: any[];
    posts?: any[];
    error?: any;
    loading?: boolean;
    idxPublishLoading?: string;
    idxUnpublishLoading?: string;
    idxSaveLoading?: string;
  } | null;
};

export const StateInitial: State = {
  SegmentTargetSequence: {
    sequenceIndex: null,
    organsMaster: [],
    loadingSegmentList: false,
    listSegmentTrees: [],
    ruleTemplates: [],
    listSegments: [],
    selectedSegmentId: "",
    selectedSegmentTreeId: "",
    organTips: [],
    posts: [],
    loading: false,
    idxPublishLoading: "",
    idxUnpublishLoading: "",
    idxSaveLoading: "",
  },
};

export type Props = {};

export type Event =
  | { message: "RunSequence"; params: {} }
  | { message: "GetMasterData"; params: {} };

export type Data = {
  division?: number;
};

type Picked = Partial<
  Pick<
    MainState,
    "buttonLoadCheck" | "errorMessage" | "successMessage" | "masterOptions" | "django" | "userId"
  >
>;

export const DataInitial = {};

type Handler<P = any, R = any> = (
  controller: WasmController<State & Picked, Event, Data, Props>,
  params: P
) => R;

/********************************************
 *
 *
 *  Constant
 *
 *
 *******************************************/

export const PREFIX = "mehealth_";
export const SEGMENT_TREE = `${PREFIX}segmentTrees`;
export const SEGMENT = `${PREFIX}segments`;
export const RULE_TEMPLATES = `${PREFIX}ruleTemplates`;
export const POST = `${PREFIX}posts`;
export const ORGAN_TIPS = `${PREFIX}organTips`;

export const MEDICAL_REPORT_GS = CONFIG.FIREBASE_PROJECT === "mehealthportal" ? "gs://medical-reports-storage-prod" : "gs://medical-reports-storage"
export const MEHEALTH_POST_GS = CONFIG.FIREBASE_PROJECT === "mehealthportal" ? "gs://mehealth-post-prod" : "gs://mehealth-post"

export const Start: Handler = async (controller, params) => {
  // const querySnapshot = await getDocs(collection(controller.db, SEGMENT_TREE));
  // const listSegmentTrees: ListSegmentTreesType[] = [];
  // querySnapshot.forEach((doc: any) => {
  //   listSegmentTrees.push({ id: doc.id, data: doc.data() });
  // });
  const listSegmentTrees = await getSegmentTree(controller);
  let organsMaster: any = []
  const queryRuleTemplates = await getDocs(collection(controller.db, RULE_TEMPLATES));
  const ruleTemplates: RuleTemplatesType[] = [];
  queryRuleTemplates.forEach((doc: any) => {
    ruleTemplates.push({ id: doc.id, data: doc.data() });
  });


  let response = await fetch(`${CONFIG.FAST_API}/api/v1/feed/organs-dropdown`, {
    method: "GET",
    headers: {
      Authorization: `Token ${controller.apiToken}`,
      "Content-Type": "application/json",
      accept: "application/json",
    }
  });


  console.log('START response: ', response);
  if (response.status === 200) {
    organsMaster = await (await response.blob()).text()
    organsMaster = JSON.parse(organsMaster)
    if ( organsMaster?.success) {
      organsMaster = organsMaster?.data
    }
    console.log('organMaster: ', organsMaster);
  }

  controller.setState(
    {
      SegmentTargetSequence: {
        sequenceIndex: "Action",
        organsMaster: organsMaster,
        listSegmentTrees: listSegmentTrees,
        ruleTemplates: ruleTemplates,
        selectedSegmentId: "",
      },
    },
    () => {
      controller.handleEvent({ message: "RunSequence", params: { ...params } });
    }
  );
};

export const Action: Handler = async (controller, params) => {
  console.log("Action ", params.action, ": params  ->", params);

  if (params.action === "QueryTreesSegment") {
    QueryTreesSegment(controller, params);
  } else if (params.action === "querySegmentFromSegmentTreesId") {
    QuerySegmentFromSegmentTreesId(controller, params);
  } else if (params.action === "NewTreeSegment") {
    NewTreeSegment(controller, params);
  } else if (params.action === "EditNameTreeSegment") {
    EditNameTreeSegment(controller, params);
  } else if (params.action === "AddSegment") {
    AddSegment(controller, params);
  } else if (params.action === "DeleteAllChildSegment") {
    DeleteAllChildSegment(controller, params);
  } else if (params.action === "AddContent") {
    AddContent(controller, params);
  } else if (params.action === "SelectSegment") {
    SelectSegment(controller, params);
  } else if (params.action === "UpdateContents") {
    return UpdateContents(controller, params);
  } else if (params.action === "SaveContent") {
    SaveContent(controller, params);
  } else if (params.action === "DeleteContent") {
    DeleteContent(controller, params);
  } else if (params.action === "Publish") {
    return Publish(controller, params);
  } else if (params.action === "UnPublish") {
    return UnPublish(controller, params);
  } else if (params.action === "GetPublicContents") {
    return GetPublicContents(controller, params);
  }
};

/******************************************************************************************
 *
 *  Firebase
 *
 * ***************************************************************************************/

const getSegmentTree = async (controller: any) => {
  const querySnapshot = await getDocs(collection(controller.db, SEGMENT_TREE));
  let listSegmentTrees: ListSegmentTreesType[] = [];
  querySnapshot.forEach((doc: any) => {
    listSegmentTrees.push({ id: doc.id, data: doc.data() });
  });
  console.log('getSegmentTree listSegmentTrees: ', listSegmentTrees);
  let state = controller.getState();
  console.log('getSegmentTree state: ', state);
  listSegmentTrees = listSegmentTrees.filter(i => (i.data.divisionId === state.selectedDivision?.id) || (i.data.created_by === Number(state.userId)) )
  console.log('getSegmentTree listSegmentTrees: ', listSegmentTrees);
  return listSegmentTrees;
};

const getSegmentFromTreeId = async (db, segmentTreeId) => {
  const segmentItem: SegmentItem[] = [];
  const querySegments = query(
    collection(db, SEGMENT),
    where("segment_tree_id", "==", segmentTreeId)
  );
  console.log("querySegments:", querySegments);
  const querySnapshot = await getDocs(querySegments);

  querySnapshot.forEach((doc: any) => {
    segmentItem.push({ id: doc.id, data: doc.data() });
  });

  return segmentItem;
};

const getAttachedPost = async (db, currentSegment) => {
  let attached_posts = currentSegment?.data?.attached_posts ?? [];

  let posts: any[] = [];
  if (attached_posts?.length > 0) {
    const results = await Promise.all(
      attached_posts.map((documentId: string) => getDoc(doc(db, POST, documentId)))
    );
    console.log("results: ", results);
    posts = results.map((i) => i.data()).filter(Boolean).filter((i) => i.is_active)
  }

  return posts;
};

const getAttachedOrganTips = async (db, currentSegment) => {
  let attached_organTips = currentSegment?.data?.attached_organTips ?? [];

  let organTips: any[] = [];
  if (attached_organTips?.length > 0) {
    const results = await Promise.all(
      attached_organTips.map((documentId: string) => getDoc(doc(db, ORGAN_TIPS, documentId)))
    );
    console.log("results: ", results);
    organTips = results.map((i) => i.data()).filter(Boolean).filter((i) => i.is_active)
  }

  return organTips;
};

const getContentsRelated = async (db, currentSegment) => {
  console.log("currentSegment: ", currentSegment);
  let posts = await getAttachedPost(db, currentSegment);
  let organTips = await getAttachedOrganTips(db, currentSegment);

  console.log("currentSegment [posts, organTips]: ", posts, organTips);
  return [posts, organTips];
};

/******************************************************************************************
 *
 *
 *  Handler
 *
 * ***************************************************************************************/

const QueryTreesSegment: Handler = async (controller, params) => {

  let listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
  let state = controller.getState();
  console.log('QueryTreesSegment listSegmentTrees: ', listSegmentTrees);
  console.log("QueryTreesSegment listTrees: ", listSegmentTrees);
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      sequenceIndex: "Action",
      listSegmentTrees: listSegmentTrees,
    },
  });
};

const QuerySegmentFromSegmentTreesId: Handler = async (controller, params) => {

  try {
    const listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
    const listSegments: SegmentItem[] = await getSegmentFromTreeId(controller.db, params.id);
    let state = controller.getState();

    console.log("querySegment: listSegments ", listSegments);
    console.log("querySegment: listSegmentTrees ", listSegmentTrees);

    state = controller.getState();
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        listSegments: listSegments,
        listSegmentTrees: listSegmentTrees,
        selectedSegmentId: "",
        selectedSegmentTreeId: params.id,
      },
    });
  } catch (error) {
    console.log("Debug ~ error querySegment collection :", error);
  }
};

const NewTreeSegment: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      loading: true,
    },
  });

  const dataTemplate: ListDataType = {
    created_at: serverTimestamp(),
    created_by: Number(state.userId),
    description: params.description,
    divisionCode: state.selectedDivision?.code,
    divisionId: state.selectedDivision?.id,
    is_active: true,
    name: params.name,
    root_segment_id: [],
    updated_at: serverTimestamp(),
  };
  console.log("Debug ~ dateTemplate:", dataTemplate);

  await addDoc(collection(controller.db, SEGMENT_TREE), dataTemplate)
    .then(async () => {
      console.log("Debug ~ Document successfully written!");
      const listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          listSegmentTrees,
          loading: false,
        },
      });
    })
    .catch((error) => {
      console.error("Debug ~ Error writing document: ", error);
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          loading: false,
        },
      });
    });
};

const EditNameTreeSegment: Handler = async (controller, params) => {
  let state = controller.getState();

  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      loading: true,
    },
  });

  await updateDoc(doc(controller.db, SEGMENT_TREE, params.id), {
    name: params.name,
    description: params.description,
    updated_at: serverTimestamp(),
  })
    .then(async () => {
      console.log("Document successfully update!");
      const listSegmentTrees: ListSegmentTreesType[] = await getSegmentTree(controller);
      const listSegments: SegmentItem[] = await getSegmentFromTreeId(controller.db, params.id);
      state = controller.getState();
      // await querySegment(controller, {id: params.id})
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          listSegments: listSegments,
          listSegmentTrees: listSegmentTrees,
          loading: false,
        },
      });
    })
    .catch((error) => {
      console.error("Error writing document: ", error);
      state = controller.getState();
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          loading: false,
        },
      });
    });
};

const AddSegment: Handler = async (controller, params) => {
  let state = controller.getState();
  console.log("addSegment state: ", state.SegmentTargetSequence);
  console.log("addSegment params: ", params);
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      loading: true,
    },
  });

  // Find RuleTemplate

  const ruleTemplate = state.SegmentTargetSequence?.ruleTemplates?.find(
    (i) => i.id === params.ruleTemplateId
  )?.data;
  const isFirst = state.SegmentTargetSequence?.listSegmentTrees?.find(
    (i) => i.id === params.parentId
  );

  let path_from_root: any[] = [];
  let segment_tree_id = "";
  let parent_segment_id = "";
  if (isFirst) {
    path_from_root = [];
    segment_tree_id = params.parentId;
    parent_segment_id = "";
  } else {
    let parentSegment = state.SegmentTargetSequence?.listSegments?.find(
      (i) => i.id === params.parentId
    );
    segment_tree_id = String(parentSegment?.data?.segment_tree_id);
    path_from_root = [...(parentSegment?.data?.path_from_root ?? []), params.parentId];
    parent_segment_id = params.parentId; /// ถ้าเป็นภายใน segment หาแบบนึง แต่ถ้าเป็นตัวแรก เป็นค่าว่าง
  }

  for (let index = 0; index < (ruleTemplate?.template?.condition_options || []).length; index++) {
    const option = ruleTemplate?.template?.condition_options[index];
    if (option) {
      const segment: SegmentData = {
        attached_content: [],
        description: params.description,
        name: option?.text || "",
        created_at: serverTimestamp(),
        updated_at: serverTimestamp(),
        seq: index,
        rule: {
          rule_type: String(ruleTemplate?.rule_type),
          operator: option?.operator,
          ...(ruleTemplate?.lab_test_master_id && {
            lab_test_master_id: ruleTemplate?.lab_test_master_id,
          }), // กรณี rule_type === "labResult"
          ...(ruleTemplate?.field && { field: ruleTemplate?.field }), // กรณี rule_type === "labResult"
          ...(option?.value && { value: option?.value }),
          ...(option?.max_value && { max_value: Number(option?.max_value) }),
          ...(option?.min_value && { min_value: Number(option?.min_value) }),
        }, // เอาของ ใน condition_options ที่ตัด text ออก เอามาใส่
        child_segment_ids: [],
        is_active: true,
        segment_tree_id,
        parent_segment_id,
        path_from_root,
        created_by: Number(state.userId),
      };
      console.log("segment: ", segment);

      await addDoc(collection(controller.db, SEGMENT), segment)
        .then(async () => {
          console.log("Debug ~ Document successfully written!");
          const listSegments: SegmentItem[] = await getSegmentFromTreeId(
            controller.db,
            segment_tree_id
          );
          controller.setState({
            SegmentTargetSequence: {
              ...state.SegmentTargetSequence,
              listSegments,
              loading: false,
            },
          });
        })
        .catch((error) => {
          console.error("Debug ~ Error writing document: ", error);
          controller.setState({
            SegmentTargetSequence: {
              ...state.SegmentTargetSequence,
              loading: false,
            },
          });
        });
    }
  }
};

const DeleteAllChildSegment: Handler = async (controller, params) => {
  let state = controller.getState();
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      loading: true,
    },
  });

  const isFirst = state.SegmentTargetSequence?.listSegmentTrees?.find(
    (i) => i.id === params.parentId
  );

  const segmentCollectionRef = collection(controller.db, SEGMENT);
  const deletePromises: any[] = [];

  // Create a query against the collection.
  let key = isFirst ? "segment_tree_id" : "parent_segment_id";
  let segment_tree_id = isFirst
    ? params.parentId
    : state.SegmentTargetSequence?.listSegments?.find((i) => i.id === params.parentId)?.data
        ?.segment_tree_id;
  const deleteQuery = await query(segmentCollectionRef, where(key, "==", params.parentId));
  const snapshot = await getDocs(deleteQuery);
  // Delete each document individually

  snapshot.forEach((doc) => {
    deletePromises.push(deleteDoc(doc.ref));
  });

  console.log("deleteAllChildSegment deletePromises: ", deletePromises);

  await Promise.all(deletePromises)
    .then(async () => {
      console.log("Document successfully update!");
      const listSegments: SegmentItem[] = await getSegmentFromTreeId(
        controller.db,
        segment_tree_id
      );
      let state = controller.getState();
      // await querySegment(controller, {id: params.id})
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          listSegments,
          loading: false,
        },
      });
    })
    .catch((error) => {
      console.error("Error writing document: ", error);
      let state = controller.getState();
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          loading: false,
        },
      });
    });
};

const AddContent: Handler = async (controller, params) => {
  let state = controller.getState();
  // let organTips = state.SegmentTargetSequence?.organTips ?? []
  if (params.type === POST) {
    let posts = state.SegmentTargetSequence?.posts ?? [];
    let append = [...posts];

    const collectionRef = collection(controller.db, POST);
    // Generate "locally" a new document for the given collection reference
    const docRef = doc(collectionRef);

    // Get the new document Id
    const documentUuid = docRef.id;
    append.unshift({ id: documentUuid, division_id: state.selectedDivision.id });
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        posts: append,
      },
    });
  } else if (params.type === ORGAN_TIPS) {
    let organTips = state.SegmentTargetSequence?.organTips ?? [];
    let append = [...organTips];

    const collectionRef = collection(controller.db, ORGAN_TIPS);
    // Generate "locally" a new document for the given collection reference
    const docRef = doc(collectionRef);
    // Get the new document Id
    const documentUuid = docRef.id;
    append.unshift({ id: documentUuid, division_id: state.selectedDivision.id });
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        organTips: append,
      },
    });
  }
};

const findMediaTagsAndText = (htmlString: string) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  const images = Array.from(doc.querySelectorAll("img"));
  const videos = Array.from(doc.querySelectorAll("iframe"));

  // Extract all text content
  const textContent = doc.body.textContent || doc.body.innerText || "";

  return {
    text: textContent.trim(),
    images: images.map((img) => img.src),
    videos: videos.map((video) => video.src),
  };
};
const SelectSegment: Handler = async (controller, params) => {
  let state = controller.getState();
  // get attached_posts
  // get attached_tips
  let currentSegment = state.SegmentTargetSequence?.listSegments?.find((i) => i.id === params.id);

  let [posts, organTips] = await getContentsRelated(controller.db, currentSegment);

  console.log("selectSegment posts: ", posts);

  console.log("selectSegment organTips: ", organTips);

  console.log("selectSegment state.SegmentTargetSequence: ", state.SegmentTargetSequence);
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      selectedSegmentId: params.id,
      organTips,
      posts,
    },
  });
};

const UpdateContents: Handler = async (controller, params) => {
  let state = controller.getState();
  console.log("UpdateContents: params: ", params);

  let ret: any;
  if (params.id) {
    if (params.type === POST) {
      let posts: any[] = state.SegmentTargetSequence?.posts || [];
      let idx = posts.findIndex((i) => i.id === params.id);
      if (idx !== -1) {
        if ("content" in params) {
          posts[idx] = { ...posts[idx], content: params.content };
        }
        if ("organTags" in params) {
          posts[idx] = { ...posts[idx], organ_tags: params.organTags };
        }
        if ("files" in params && "info" in params) {
          // Upload file

          console.log("UpdateContents params.files?.[0]: ", params.files?.[0]);
          // upload to storage
          ret = await uploadFile(controller, {
            file: params.files?.[0],
            fileName: params.files?.[0]?.name,
            bucketName: MEHEALTH_POST_GS,
            key: 1,
            idx: 0,
          });
        }

        if (params.content) {
          let media = findMediaTagsAndText(params.content);
          console.log("media: ", media);
          let sliceText = media?.text?.slice(0, 175) || ""
          console.log('sliceText: ', sliceText);
          posts[idx] = {
            ...posts[idx],
            previews_text: media?.text,
            shorten_text: sliceText,
            previews_picture: media.images,
            previews_video: media.videos,
          };
        }

        // if ("imageInfo" in params && "state" in params && "index" in params) {

        //   // Image setup
        //   console.log('Image setup : ');
        //   let previews_picture = [...(posts[idx]?.previews_picture ?? [])]
        //   console.log('draftImages: ', previews_picture);
        //   switch (params.state) {
        //     case "create":
        //     case "update":
        //       previews_picture[params.index] = {}
        //       previews_picture[params.index].imageInfo = params.imageInfo;
        //       previews_picture[params.index].targetImgElement = params.targetImgElement;
        //       posts[idx] = {
        //         ...posts[idx],
        //         previews_picture,
        //       };
        //       break;
        //     case "delete":
        //       previews_picture[params.index] = null;
        //       posts[idx] = {
        //         ...posts[idx],
        //         previews_picture,
        //       };
        //       break;
        //     default:
        //       break;
        //   }
        // }
        console.log("UpdateContents state.SegmentTargetSequence: ", state.SegmentTargetSequence);
        console.log("UpdateContents posts: ", posts);
        controller.setState({
          SegmentTargetSequence: {
            ...state.SegmentTargetSequence,
            posts: [...posts],
            loading: false,
          },
        });
      }
    } else if (params.type === ORGAN_TIPS) {
      let organTips: any[] = state.SegmentTargetSequence?.organTips || [];
      let idx = organTips.findIndex((i) => i.id === params.id);
      if (idx !== -1) {
        if ("organ" in params) {
          organTips[idx] = { ...organTips[idx], organ: params.organ };
        }
        if ("content" in params) {
          organTips[idx] = { ...organTips[idx], content: params.content };
        }

        if ("suggestionLabs" in params) {
          organTips[idx] = { ...organTips[idx], suggestion_labs: params.suggestionLabs };
        }
        console.log("UpdateContents state.SegmentTargetSequence: ", state.SegmentTargetSequence);
        console.log("UpdateContents organTips: ", organTips);
        controller.setState({
          SegmentTargetSequence: {
            ...state.SegmentTargetSequence,
            organTips: [...organTips],
            loading: false,
          },
        });
      }
    }
  }

  return ret;
};

const SaveContent: Handler = async (controller, params) => {
  controller.setState((prev) => ({
    SegmentTargetSequence: {
      ...prev.SegmentTargetSequence,
      idxSaveLoading: params.id,
    },
  }));
  let state = controller.getState();

  // get attached_posts
  // get attached_tips
  let currentSegment = state.SegmentTargetSequence?.listSegments?.find(
    (i) => i.id === state.SegmentTargetSequence?.selectedSegmentId
  );
  console.log("SaveContent params: ", params);
  console.log("SaveContent state.SegmentTargetSequence: ", state.SegmentTargetSequence);
  let attached_posts = currentSegment?.data?.attached_posts ?? [];
  let attached_organTips = currentSegment?.data?.attached_organTips ?? [];
  // loop get Tips and post

  if (params.type === POST) {
    // Update

    // ONSnapshot
    // const unsubPost = onSnapshot(doc(controller.db, POST, params.id), (snapshot) => {
    //   console.log('SaveContent unsubPost snapshot: ', snapshot);
    //   if (!snapshot.metadata.hasPendingWrites) {
    //     console.log("SaveContent unsubPost onSnapshot Current data: ", snapshot.data());
    //   }
    // });

    let previewPost = state.SegmentTargetSequence?.posts?.find((i) => i.id === params.id);
    console.log("previewPost: ", previewPost);

    // post
    if (attached_posts.some((id: string) => id === params.id)) {
      // Inject previews

      /************************************
       *
       *  update POST
       *
       ************************************/

      console.log("SaveContent update POST ");

      await updateDoc(doc(controller.db, POST, params.id), {
        content: params.content,
        organ_tags: params.organTags,
        // division_id: state.selectedDivision?.id,
        ...(previewPost?.previews_text && { previews_text: previewPost.previews_text }),
        ...(previewPost?.previews_picture && { previews_picture: previewPost.previews_picture }),
        ...(previewPost?.previews_video && { previews_video: previewPost.previews_video }),
        updated_at: serverTimestamp(),
        isEdit: true,
        updated_by: { id: state.django?.user.id, name: state.django?.user.full_name },
        // published_at: deleteField(),
      });
    } else {
      /************************************
       *
       *  create POST
       *
       ************************************/

      console.log("SaveContent create POST  ");
      await updateDoc(doc(controller.db, SEGMENT, state.SegmentTargetSequence?.selectedSegmentId), {
        attached_posts: [params.id, ...attached_posts],
        updated_at: serverTimestamp(),
        // published_at: deleteField(),
      });

      await setDoc(doc(controller.db, POST, params.id), {
        id: params.id,
        isEdit: true,
        is_active: true,
        content: params.content,
        division_id: state.selectedDivision?.id,
        ...(previewPost?.previews_text && { previews_text: previewPost.previews_text }),
        ...(previewPost?.previews_picture && { previews_picture: previewPost.previews_picture }),
        ...(previewPost?.previews_video && { previews_video: previewPost.previews_video }),
        updated_at: serverTimestamp(),
        created_at: serverTimestamp(),
        organ_tags: params.organTags,
        // is_latest_version: false,
        status: "draft",
        version: 1,
        author_id: Number(state.userId),
        content_storage: {
          bucket_path: null,
          content_url: null,
          content_size: null,
          content_hash: null,
        },
        updated_by: { id: state.django?.user.id, name: state.django?.user.full_name },
      });
    }

    console.log("previewPost.previews_text: ", previewPost.previews_text);
  } else if (params.type === ORGAN_TIPS) {
    // const unsubOrganTips = onSnapshot(doc(controller.db, ORGAN_TIPS, params.id), (snapshot) => {
    //   console.log('SaveContent unsubOrganTips snapshot: ', snapshot);
    //   if (!snapshot.metadata.hasPendingWrites) {
    //     console.log("SaveContent unsubOrganTips onSnapshot Current data: ", snapshot.data());
    //   }
    // });

    let previewOrganTips = state.SegmentTargetSequence?.organTips?.find((i) => i.id === params.id);
    console.log("previewOrganTips: ", previewOrganTips);

    // organTips
    if (attached_organTips.some((id: string) => id === params.id)) {
      /************************************
       *
       *  update Organ Tips
       *
       ************************************/
      console.log("SaveContent update Organ Tips");
      await updateDoc(doc(controller.db, ORGAN_TIPS, params.id), {
        isEdit: true,
        content: params.content,
        // division_id: state.selectedDivision?.id,
        organ: params.organ,
        ...(previewOrganTips?.previews_text && { previews_text: previewOrganTips.previews_text }),
        ...(previewOrganTips?.previews_picture && {
          previews_picture: previewOrganTips.previews_picture,
        }),
        ...(previewOrganTips?.previews_video && {
          previews_video: previewOrganTips.previews_video,
        }),
        suggestion_labs: params.suggestionLabs,
        updated_at: serverTimestamp(),
        updated_by: { id: state.django?.user.id, name: state.django?.user.full_name },
        // published_at: deleteField(),
      });
    } else {
      /************************************
       *
       *  create Organ Tips
       *
       ************************************/

      console.log(
        "SaveContent create Organ Tips state.SegmentTargetSequence?.selectedSegmentId:",
        state.SegmentTargetSequence?.selectedSegmentId
      );
      console.log("SaveContent create Organ Tips params.idd:", params.id);
      await updateDoc(doc(controller.db, SEGMENT, state.SegmentTargetSequence?.selectedSegmentId), {
        attached_organTips: [params.id, ...attached_organTips],
      });

      await setDoc(doc(controller.db, ORGAN_TIPS, params.id), {
        id: params.id,
        isEdit: true,
        is_active: true,
        content: params.content,
        division_id: state.selectedDivision?.id,
        organ: params.organ,
        suggestion_labs: params.suggestionLabs || [],
        ...(previewOrganTips?.previews_text && { previews_text: previewOrganTips.previews_text }),
        ...(previewOrganTips?.previews_picture && {
          previews_picture: previewOrganTips.previews_picture,
        }),
        ...(previewOrganTips?.previews_video && {
          previews_video: previewOrganTips.previews_video,
        }),
        updated_at: serverTimestamp(),
        created_at: serverTimestamp(),
        // is_latest_version: false,
        status: "draft",
        version: 1,
        author_id: Number(state.userId),
        content_storage: {
          bucket_path: null,
          content_url: null,
          content_size: null,
          content_hash: null,
        },
        updated_by: { id: state.django?.user.id, name: state.django?.user.full_name },
      });
    }
  }

  setTimeout(async () => {
    const listSegments: SegmentItem[] = await getSegmentFromTreeId(
      controller.db,
      state.SegmentTargetSequence?.selectedSegmentTreeId
    );
    console.log("SaveContent listSegments: ", listSegments);

    let [posts, organTips] = await getContentsRelated(
      controller.db,
      listSegments?.find((i: any) => i.id === state.SegmentTargetSequence?.selectedSegmentId)
    );
    console.log("posts, organTips: ", posts, organTips);
    console.log("SaveContent state.SegmentTargetSequence: ", state.SegmentTargetSequence);

    state = controller.getState();
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        listSegments: listSegments,
        posts,
        organTips,
        idxSaveLoading: "",
      },
    });
  }, 5000);
};

const DeleteContent: Handler = async (controller, params) => {
  let state = controller.getState();

  // get attached_posts
  // get attached_tips
  let currentSegment = state.SegmentTargetSequence?.listSegments?.find(
    (i) => i.id === state.SegmentTargetSequence?.selectedSegmentId
  );
  // console.log('DeleteContent currentSegment: ', currentSegment);
  // console.log("DeleteContent params: ", params);
  // console.log("DeleteContent state.SegmentTargetSequence: ", state.SegmentTargetSequence);
  let attached_posts = currentSegment?.data?.attached_posts ?? [];
  let attached_organTips = currentSegment?.data?.attached_organTips ?? [];
  // console.log('DeleteContent attached_posts: ', attached_posts);
  // console.log('DeleteContent attached_organTips: ', attached_organTips);

  // Check Is new / not save yet looking in attached_posts
  let isNew = false
  if ( params.type === POST ) {
    isNew = !attached_posts?.some((i: string) => i === params.contentId)
  } else if (params.type === ORGAN_TIPS) {
    isNew = !attached_organTips?.some((i: string) => i === params.contentId)
  }

  if (!isNew) {
    let type = params.type === POST ? "posts" : "organ-tips";
    let response = await fetch(`${CONFIG.FAST_API}/api/v1/feed/${type}/${params.contentId}/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Token ${controller.apiToken}`,
        "Content-Type": "application/json",
        accept: "application/json",
      },
      body: JSON.stringify({}),
    });
    console.log("Delete response: ", response);

    state = controller.getState();
    if (response.status !== 200) {
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          loading: false,
        },
      });
      console.warn("Cannot delete! ")
      return
    }
  }

  if (params.type === POST) {
    // await deleteDoc(doc(controller.db, POST, params.id));
    attached_posts = attached_posts?.filter((id: string) => id !== params.contentId);
    await updateDoc(doc(controller.db, SEGMENT, state.SegmentTargetSequence?.selectedSegmentId), {
      attached_posts,
    });
  } else if (params.type === ORGAN_TIPS) {
    // await deleteDoc(doc(controller.db, ORGAN_TIPS, params.id));
    attached_organTips = attached_organTips.filter((id: string) => id !== params.contentId);
    await updateDoc(doc(controller.db, SEGMENT, state.SegmentTargetSequence?.selectedSegmentId), {
      attached_organTips,
    });
  }

  state = controller.getState();
  const listSegments: SegmentItem[] = await getSegmentFromTreeId(
    controller.db,
    state.SegmentTargetSequence?.selectedSegmentTreeId
  );
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      listSegments: listSegments,
      ...(params.type === POST && {
        posts: state.SegmentTargetSequence.posts?.filter((data) =>
          attached_posts.includes(data.id)
        ),
      }),
      ...(params.type === ORGAN_TIPS && {
        organTips: state.SegmentTargetSequence.organTips?.filter((data) =>
          attached_organTips.includes(data.id)
        ),
      }),
      loading: false,
    },
  });

};

const Publish: Handler = async (controller, params) => {
  controller.setState((prev) => ({
    SegmentTargetSequence: {
      ...prev.SegmentTargetSequence,
      idxPublishLoading: params.contentId,
    },
  }));

  let type = params.type === POST ? "posts" : "organ-tips";
  let response = await fetch(`${CONFIG.FAST_API}/api/v1/feed/${type}/${params.contentId}/publish`, {
    method: "POST",
    headers: {
      Authorization: `Token ${controller.apiToken}`,
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify({}),
  });

  console.log("Publish response: ", response);

  let state = controller.getState();
  if (response.status === 200) {
    let typeName = params.type === POST ? "posts" : "organTips";
    console.log("Publish typeName: ", typeName);
    let typeCollection = params.type === POST ? POST : ORGAN_TIPS;
    console.log("Publish typeCollection: ", typeCollection);
    // let version = state.SegmentTargetSequence?.[typeName]?.find( (i: any) => i.id === params.contentId)?.version || 1
    // console.log('Publish state.SegmentTargetSequence?.[typeName]: ', state.SegmentTargetSequence?.[typeName]);
    // console.log('Publish version: ', version);
    await updateDoc(doc(controller.db, typeCollection, params.contentId), {
      version: increment(1),
      published_version: params.publishedVersion,
      isEdit: false,
    });

    setTimeout(async () => {
      state = controller.getState();
      let currentSegment = state.SegmentTargetSequence?.listSegments?.find(
        (i) => i.id === state.SegmentTargetSequence?.selectedSegmentId
      );
      let [posts, organTips] = await getContentsRelated(controller.db, currentSegment);
      console.log("Publish [posts, organTips]: ", [posts, organTips]);
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          posts,
          organTips,
          idxPublishLoading: "",
        },
      });
    }, 5000);
  } else {
    state = controller.getState();
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        idxPublishLoading: "",
      },
    });
  }
};
const UnPublish: Handler = async (controller, params) => {
  controller.setState((prev) => ({
    SegmentTargetSequence: {
      ...prev.SegmentTargetSequence,
      idxUnpublishLoading: params.contentId,
    },
  }));

  let type = params.type === POST ? "posts" : "organ-tips";
  let response = await fetch(`${CONFIG.FAST_API}/api/v1/feed/${type}/${params.contentId}/unpublish`, {
    method: "POST",
    headers: {
      Authorization: `Token ${controller.apiToken}`,
      "Content-Type": "application/json",
      accept: "application/json",
    },
    body: JSON.stringify({}),
  });

  console.log("UnPublish response: ", response);

  let state = controller.getState();
  if (response.status === 200) {
    let typeName = params.type === POST ? "posts" : "organTips";
    console.log("UnPublish typeName: ", typeName);
    let typeCollection = params.type === POST ? POST : ORGAN_TIPS;
    console.log("UnPublish typeCollection: ", typeCollection);
    // let version = state.SegmentTargetSequence?.[typeName]?.find( (i: any) => i.id === params.contentId)?.version || 1
    // console.log('Publish state.SegmentTargetSequence?.[typeName]: ', state.SegmentTargetSequence?.[typeName]);
    // console.log('Publish version: ', version);
    await updateDoc(doc(controller.db, typeCollection, params.contentId), {
      published_version: deleteField(),
      isEdit: false,
    });

    setTimeout(async () => {
      state = controller.getState();
      let currentSegment = state.SegmentTargetSequence?.listSegments?.find(
        (i) => i.id === state.SegmentTargetSequence?.selectedSegmentId
      );
      let [posts, organTips] = await getContentsRelated(controller.db, currentSegment);
      console.log("UnPublish [posts, organTips]: ", [posts, organTips]);
      controller.setState({
        SegmentTargetSequence: {
          ...state.SegmentTargetSequence,
          posts,
          organTips,
          idxUnpublishLoading: "",
        },
      });
    }, 5000);
  } else {
    state = controller.getState();
    controller.setState({
      SegmentTargetSequence: {
        ...state.SegmentTargetSequence,
        idxUnpublishLoading: "",
      },
    });
  }
};

const GetPublicContents: Handler = async (controller, params) => {

  controller.setState((prev) => {
    return { SegmentTargetSequence: { ...prev.SegmentTargetSequence, publishJson: null } };
  })

  const firebaseApp = getApp();
  const storage = getStorage(firebaseApp, MEDICAL_REPORT_GS);
  const type = params.type === POST ? "posts" : "tips"
  console.log('GetPublishContents: ', `${type}/published/${params.id}/v${params.version}.json`);
  const starsRef = ref(storage, `${type}/published/${params.id}/v${params.version}.json`);
    getDownloadURL(starsRef)
      .then((url) => {
      // `url` is the download URL for 'images/stars.jpg'

      // This can be downloaded directly:
      const xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = (event) => {
        xhr.response?.text()?.then((text: string) => {
          console.log("text", text)
          let publishJson = JSON.parse(text)
          controller.setState((prev) => {
            return { SegmentTargetSequence: { ...prev.SegmentTargetSequence, publishJson: publishJson } };
          })
        })
      };
      xhr.open('GET', url);
      xhr.send();
    })
    .catch((error) => {
        // A full list of error codes is available at
    // https://firebase.google.com/docs/storage/web/handle-errors
    switch (error.code) {
      case 'storage/object-not-found':
        // File doesn't exist
        console.log("File doesn't exist")
        break;
      case 'storage/unauthorized':
        // User doesn't have permission to access the object
         console.log("User doesn't have permission to access the object")
        break;
      case 'storage/canceled':
        // User canceled the upload
        console.log("User canceled the upload")
        break;

      case 'storage/unknown':
        // Unknown error occurred, inspect the server response
        console.log("Unknown error occurred, inspect the server response")
        break;
    }
    });
}

const SaveOrganTips: Handler = async (controller, params) => {
  let state = controller.getState();
  // get attached_posts
  // get attached_tips
  // let currentSegment = state.SegmentTargetSequence?.listSegments?.find(i => i.id === state.SegmentTargetSequence?.selectedSegmentId)
  // let attached_posts = currentSegment?.data?.attached_posts ?? []
  // let attached_tips = currentSegment?.data?.attached_tips ?? []
  // // loop get Tips and post

  // const postsRef = collection(controller.db, POST);
  // const organTipsRef = collection(controller.db, ORGAN_TIPS);

  // // Create a query against the collection.
  // const qPosts = query(postsRef, where("id", "in" , attached_posts));
  // const qOrganTips = query(organTipsRef, where("id", "in" , attached_tips));

  // let posts: any[] = []
  // let organTips: any[] = []

  // const qPostsSnapshot = await getDocs(qPosts);
  // qPostsSnapshot.forEach((doc) => {
  //   // doc.data() is never undefined for query doc snapshots
  //   posts.push(doc)
  //   console.log(doc.id, " => ", doc.data());
  // });
  // const qOrganTipsSnapshot = await getDocs(qOrganTips);
  // qOrganTipsSnapshot.forEach((doc) => {
  //   // doc.data() is never undefined for query doc snapshots
  //   console.log(doc.id, " => ", doc.data());
  //   organTips.push(doc)
  // });

  console.log("selectSegment state.SegmentTargetSequence: ", state.SegmentTargetSequence);
  controller.setState({
    SegmentTargetSequence: {
      ...state.SegmentTargetSequence,
      selectedSegmentId: params.id,
      organTips,
      posts,
    },
  });
};

// Utils
const uploadFile: Handler = async (
  controller,
  params: {
    file: File;
    fileName?: string;
    bucketName: `gs://${string}`;
    key?: string;
    idx?: number;
  }
): Promise<{ key: string; url: string }> => {
  const fileName = `${params.idx}_${params.file.name}`;
  const objectPath = `images/${fileName}`; // no leading slash for Storage paths

  // You can pass a full gs:// URL directly to ref()
  const fileRef = ref(controller.storage, `${params.bucketName}/${objectPath}`);

  const metadata = params.file?.type ? { contentType: params.file.type } : undefined;
  const uploadTask = uploadBytesResumable(fileRef, params.file, metadata);

  return new Promise<{ key: string; url: string }>((resolve, reject) => {
    uploadTask.on(
      "state_changed",
      // progress callback (optional)
      (snapshot) => {
        // e.g., params.onProgress?.(snapshot.bytesTransferred / snapshot.totalBytes);
      },
      // error
      (error) => {
        console.error(error);
        reject(error);
      },
      // complete
      async () => {
        try {
          const url = await getDownloadURL(uploadTask.snapshot.ref);
          resolve({ key: params.key || "", url });
        } catch (e) {
          reject(e);
        }
      }
    );
  });
};
